import { useMemo } from 'react'
import { useVerticalConfig, useVerticalModule } from '@lipaflow/shared'
import { collects } from './features'

export interface SettingsTab { id: string; label: string; href: string }

/**
 * The sections of Settings, in order: one list for the menu's tab bar and the
 * page, so they never disagree (2026-10-16). A vertical adds its own sections
 * and, when it sends its own payer messages, the generic reminder and pause
 * sections step aside (its Messages section holds both).
 */
export function useSettingsTabs(): SettingsTab[] {
  const verticalModule = useVerticalModule()
  const { features } = useVerticalConfig()
  return useMemo(() => {
    const own = Boolean(verticalModule?.ownsPayerMessages)
    return [
      { id: 'general', label: 'Organisation', href: '/settings' },
      { id: 'team', label: 'Team & roles', href: '/settings/team' },
      ...(verticalModule?.settingsTabs ?? []).map(({ id, label }) => ({ id, label, href: `/settings/${id}` })),
      // Payment reminders: only for a plan that collects (not the CBC suite alone).
      ...(collects(features) && !own ? [{ id: 'reminders', label: 'Reminders', href: '/settings/reminders' }] : []),
      ...(own ? [] : [{ id: 'controls', label: 'Pause messages', href: '/settings/controls' }]),
    ]
  }, [verticalModule, features])
}
